import React from 'react';
import FileBase64 from '../util/Input64';
import { Select, Input, AutoComplete, Button, message, Tag, InputNumber, Icon, Tooltip, Radio, Popover, Popconfirm, Modal, Collapse  } from 'antd';
import { Row, Col } from 'reactstrap';
import EditOff from './EditOff';
import SERVER_URL from '../Global';
import { Link } from 'react-router-dom';
import HandleOff from './../Wizard/HandleOff';
import CardDetailed from '../util/compCardDetailed';

const { Option } = Select;
const { TextArea } = Input;

message.config({
    top: 50,
    duration: 3,
    maxCount: 5
});

class EditComp extends React.Component {
    constructor(props) {
        super(props);
        let typo = 1;
        let categories = []
        let references = []
        let offices = []
        let status = null
        let statusSon = null

        if (this.props.company.status == 0 || this.props.company.status == 2) {
            status = this.props.company.status
        } else {
            status = 5
            statusSon = this.props.company.status
        }

        var sorted_cat = this.props.company.brCompanyCategories.sort((a, b) => {
            return new Date(a.created).getTime() -
                new Date(b.created).getTime()
        })

        sorted_cat.map(cat => {
            categories.push({ name: cat.companyCategories.name, id: cat.catId, remove: false })
        })

        let isPrincipal = true
        if (this.props.company.offices.length != 0) {
            var indexMainOff = this.props.company.offices.findIndex(obj => obj.sort == 1);
            this.props.company.offices[indexMainOff].isPrincipal
        }

        this.props.company.offices.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(off => {
            offices.push({ data: off, id: off.officeId, show: true, sort: off.sort })
        })

        this.props.company.companyLinks.map(link => {
            references.push({ name: link.companyLinkTo.name, id: link.companyLinkTo.companyId, remove: false })
        })

        if (this.props.typologyId != null) { typo = this.props.typologyId }
        this.state = {
            loading: false,
            user: this.props.user,
            company: this.props.company,
            properties: this.props.properties,
            categories: [],
            tipologies: this.props.tipologies,
            companies: [],
            companiesBrandsSigns:[],
            contactsOffice: ['0'],
            contactsHr: ['0'],
            detailsOff: offices,
            contactId: 0,
            offId: 0,
            compName: this.props.company.name,
            lunghezza: false,
            categoriesTag: categories,
            categoriesRemoved: [],
            links: references,
            linksRemoved: [],
            companyTypology: this.props.company.companyTypologyTrValue,
            description: this.props.company.description,
            compCreated: true,
            compId: this.props.company.companyId,
            companyImage: this.props.company.companyImage,
            offCreated: false,
            officeId: '',
            propId: '',
            hroId: '',
            officeContactText: '',
            position: 'relative',
            producerId: this.props.company.companyProducerCompanyId,
            distributerId: this.props.company.companyDistributorCompanyId,
            parentId: this.props.company.companyParentCompanyId,
            licenserId: this.props.company.companyLicenserCompanyId,
            parentName: '',
            offName: '',
            pIva: this.props.company.pIva,
            contactHistory: [],
            notes: this.props.company.notes,
            propId: 6,
            contactSaved: false,
            linksRemoved: [],
            companySaved: true,
            status: status,
            hasBeenDeleted: false,
            pivaTooShort: false,
            pivaTooLong: false,
            compNameFieldEmptyAlert: false,
            compTypFieldEmptyAlert: false,
            compCatFieldEmptyAlert: false,
            allSaved: false,
            mandatoryCompanyName: true,
            mandatoryTyp: true,
            catName: '',
            showSameName: false,
            sameNameComp: [],
            workFlow: this.props.workFlow,
            imageType: this.props.company.imageType,
            sort: this.props.company.sort,
            everyOffCreated: true,
            sonNoParent: false,
            statusSon: statusSon,
            principal: isPrincipal,
            footer: this.props.company.footer,
            mandatoryCat: true,
            companyCollaborationFor: [],
            companyLinkedMe: [],
            companyProducedByMe: [],
            companyDistributedByMe: [],
            companyLicensedByMe: [],
            hasDetail: false,
            companyDetail: [],
            visible: false,
            isBecomingSon: false,
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleFooterChange = this.handleFooterChange.bind(this);
        this.handlePiva = this.handlePiva.bind(this);
        this.handleCat = this.handleCat.bind(this);
        this.handleTyp = this.handleTyp.bind(this);
        this.saveCompany = this.saveCompany.bind(this);
        this.saveCategories = this.saveCategories.bind(this);
        this.saveOffice = this.saveOffice.bind(this);
        this.clearCat = this.clearCat.bind(this);

        this.handleHro = this.handleHro.bind(this);
        this.handleContactText = this.handleContactText.bind(this);
        this.addOff = this.addOff.bind(this);
        this.handleTagChange = this.handleTagChange.bind(this);
        this.handleNoteChange = this.handleNoteChange.bind(this);
        this.catNameWritten = this.catNameWritten.bind(this);
        this.isNameUnique = this.isNameUnique.bind(this);

        this.handleDist = this.handleDist.bind(this);
        this.handleLicn = this.handleLicn.bind(this);
        this.handleProd = this.handleProd.bind(this);
        this.handleFather = this.handleFather.bind(this);
        this.handleOffNameChange = this.handleOffNameChange.bind(this);
        this.handleLink = this.handleLink.bind(this);
        this.searchCompany = this.searchCompany.bind(this);
        this.addLink = this.addLink.bind(this);
        this.removeTag = this.removeTag.bind(this);
        this.removeLinkTag = this.removeLinkTag.bind(this);
        this.deleteCompany = this.deleteCompany.bind(this);
        this.addChildComp = this.addChildComp.bind(this);
        this.checkAllSaved = this.checkAllSaved.bind(this);
        this.checkAndRestart = this.checkAndRestart.bind(this);
        this.saveUniqueName = this.saveUniqueName.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.showGeoregion = this.showGeoregion.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.moveOffice = this.moveOffice.bind(this);
        this.offCreated = this.offCreated.bind(this);
        this.principalOk = this.principalOk.bind(this);
        this.showModal = this.showModal.bind(this);
    }

    componentDidMount() {
        fetch(
            `${SERVER_URL + 'api/companycategory/list'}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.state.user}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "name": '',
                "page": 1,
                "totalPages": 0,
                "totalItems": 0,
                "pageSize": 999,
                "pageSizeOptions": null,
                "ordering": {
                    "orderPropertyName": 'name',
                    "order": 1
                },
                "firstItemNumber": 0,
                "lastItemNumber": 0,
                "entityId": 0
            })
        }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ categories: res.data }, this.setState({ catLoad: false }));
                } else {
                    this.setState({ categories: [] })
                }
            })


        //companies
        fetch(
            `${SERVER_URL + 'api/company/list?lang=en'}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.state.user}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "page": 1,
                "pageSize": 25,
                "TypologyName": "Company",
                "ExcludeParentId": this.state.compId,
                "ExcludeId": this.state.compId,
                "companyStatusList": [5, 1, 0, 4, 3],
                "CompanyNameStartWith": '[a]%',
                "ordering": {
                    "orderPropertyName": "name",
                    "order": 1
                }
            })
        }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {

                    let companies = []

                    res.data.map(comp => {
                        if (comp.companyId != this.state.compId) {
                            companies.push(comp)
                        }
                    })

                    this.setState({ companies: companies, mandatoryCat: true })
                    this.props.changeAccordion()
                }
            })

        // References 
        fetch(
            `${SERVER_URL + "api/company/references/" + this.state.compId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    }
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({
                        companyCollaborationFor: res.data.companyCollaborationFor != null ? res.data.companyCollaborationFor : [],
                        companyLinkedMe: res.data.companyLinkedMe != null ? res.data.companyLinkedMe : [],
                        companyProducedByMe: res.data.companyProducedByMe != null ? res.data.companyProducedByMe: [],
                        companyDistributedByMe: res.data.companyDistributedByMe != null ? res.data.companyDistributedByMe : [],
                        companyLicensedByMe: res.data.companyLicensedByMe != null ? res.data.companyLicensedByMe : []
                    })
                })        
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.workFlow !== prevProps.workFlow) {
            this.setState({ workFlow: this.props.workFlow }, this.saveCompany)
        } else if (this.props.company !== prevProps.company) {
            
            let status = null
            let statusSon = null
            let references = []
            let offices = []

            if (this.props.company.status == 0 || this.props.company.status == 2) {
                status = this.props.company.status
            } else if (this.props.company.companyParentCompanyId == null) {
                status = 5
            } else {
                status = 5
                statusSon = this.props.company.status
            }

            this.props.company.companyLinks.map(link => {
                references.push({ name: link.companyLinkTo.name, id: link.companyLinkTo.companyId, remove: false })
            })

            this.props.company.offices.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(off => {
                offices.push({ data: off, id: off.officeId, show: true, sort: off.sort })
            })

            this.setState({
                company: this.props.company,
                compName: this.props.company.name,
                companyTypology: this.props.company.companyTypologyTrValue,
                description: this.props.company.description,
                companyImage: this.props.company.companyImage,
                producerId: this.props.company.companyProducerCompanyId,
                distributerId: this.props.company.companyDistributorCompanyId,
                parentId: this.props.company.companyParentCompanyId,
                pIva: this.props.company.pIva,
                notes: this.props.company.notes,
                status: status,
                statusSon: statusSon,
                imageType: this.props.company.imageType,
                sort: this.props.company.sort,
                links: references,
                detailsOff: offices
            })
        }
    }


    principalOk(checked) {
        this.setState({ principal: checked })
    }

    handleNameChange(event) {
        //assegna il nome allo stato, se il nome non è vuoto, toglie i mandatory
        this.setState({ compName: event.target.value, mandatoryCompanyName: true, labelNameVisibility: false, companySaved: false });
        if (event.target.value.length === 0) {
            this.setState({ mandatoryCompanyName: false })
        }
        if (event.target.value.length > 0) {
            this.setState({ labelNameVisibility: true, compNameFieldEmptyAlert: false })
        }
    }

    deleteImage() {
        //rimuove l'immagine
        fetch(
            `${SERVER_URL + 'api/company/image/hard/' + this.state.compId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
            }
        )
        this.setState({ companyImage: null, companySaved: false })        
    }

    isNameUnique() {
        //controlla che non ci siano compagnie con lo stesso nome, se ci sono, le assegna allo stato e richiama la checkname
        if (this.state.compName) {
            fetch(
                `${SERVER_URL + 'api/company/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CompanyUniqueName": this.state.compName,
                        "page": 1,
                        "PageSize": 15,
                        "companyStatusList": [5, 1, 0, 4, 3]
                    })
                }
            ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    let sameNameComp = res.data
                    var indexComp = sameNameComp.findIndex(obj => obj.companyId == this.state.compId);

                    if (indexComp == -1) {
                        this.setState({ sameNameComp: sameNameComp })
                    } else {
                        if (res.data.length > 1) {
                            this.setState({ sameNameComp: sameNameComp })
                        }
                    }
                }
                else {
                    this.setState({ sameNameComp: [] })
                }
            })
        }
    }

    showGeoregion() {

    }

    saveUniqueName() {
        //salva la compagnia nonostante condivida il nome con altre compagnie
        if ( this.state.mandatoryCat && this.state.compName !== '' && this.state.compCreated === true ) {
            this.setState({ loading: true, showSameName: false, sameNameComp: [] })

            let oggetti = []

            this.state.categoriesTag.map(tag => {
                if (!tag.remove) {
                    oggetti.push(tag.id)
                }
            })

            fetch(
                `${SERVER_URL + "api/company"}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.compName,
                        "companyId": this.state.compId,
                        "companyTypologyTrValue": this.state.companyTypology,
                        'companyImage': this.state.companyImage,
                        'CompanyProducerCompanyId': this.state.producerId,
                        'CompanyDistributorCompanyId': this.state.distributerId,
                        'DistributedBy': this.state.distributerId,
                        'CompanyLicenserCompanyId': this.state.licenserId,
                        'sort': this.state.sort,
                        'companyParentCompanyId': this.state.parentId,
                        'pIva': this.state.pIva,
                        'link': `${this.state.linkId}`,
                        'notes': this.state.notes,
                        "Workflow": this.state.workFlow,
                        "Status": this.state.status,
                        "imageType": this.state.imageType
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ compCreated: true, loading: false, compId: res.data, companySaved: true }, this.addOff);
                    document.getElementById("stepWorkflow").style.color = "#1890ff";
                    document.getElementById("stepWorkflow").style.pointerEvents = "initial";

                    this.addLink();

                    this.saveCategories(0)
                })
        }
        if (this.state.categoriesTag !== [] && this.state.compName !== '' && this.state.compCreated === true) {
            this.setState({ loading: true })

            let oggetti = []

            this.state.categoriesTag.map(tag => {
                if (!tag.remove) {
                    oggetti.push(tag.id)
                }
            })

            fetch(`${SERVER_URL + 'api/company'}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'name': `${this.state.compName}`,
                    "companyTypologyTrValue": this.state.companyTypology,
                    'companyImage': this.state.companyImage,
                    'description': this.state.description,
                    'sort': this.state.sort,
                    'companyId': `${this.state.compId}`,
                    'CompanyProducerCompanyId': this.state.producerId,
                    'CompanyDistributorCompanyId': this.state.distributerId,
                    'CompanyLicenserCompanyId': this.state.licenserId,
                    'companyParentCompanyId': this.state.parentId,
                    'pIva': this.state.pIva,
                    'notes': this.state.notes,
                    "Workflow": this.state.workFlow,
                    "Status": this.state.status,
                    "imageType": this.state.imageType
                })
            }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ loading: false, companySaved: true })

                    this.saveCategories(0)

                    this.addLink();
                }
            )
        }
        if (this.state.compName === '' || !this.state.compName) {
            this.setState({ compNameFieldEmptyAlert: true })
        }
        if (this.state.companyTypology === '') {
            this.setState({ compTypFieldEmptyAlert: true })
        }
        if (!this.state.mandatoryCat) {
            this.setState({ compCatFieldEmptyAlert: true })
        }
    }

    showModal(idComp) {
        window.location = "/edit?id=" + idComp
    }

    handleDescriptionChange(event) {
        //assegna la descrizione
        this.setState({ description: event.target.value, companySaved: false });
    }

    handleFooterChange(event) {
        //assegna la descrizione
        if (event.target.value.length === 0) {
            this.setState({ footer: null, companySaved: false })
        } else {
            this.setState({ footer: event.target.value, companySaved: false });
        }
    }

    handlePiva(event) {
        if (event.target.value.length < 11 && event.target.value.length !== 0) {
            this.setState({ pivaTooShort: true, companySaved: false, pivaTooLong: false });
        } else if (event.target.value.length > 11) {
            this.setState({ pivaTooShort: false, pivaTooLong: true, companySaved: false });
        } else if (event.target.value.length === 11) {
            this.setState({ pIva: event.target.value, pivaTooShort: false, pivaTooLong: false, companySaved: false });
        } else if (event.target.value.length === 0) {
            this.setState({ pivaTooShort: false, pivaTooLong: false, companySaved: false, pIva: null });
        }
    }

    handleNoteChange(event) {
        this.setState({ notes: event.target.value, companySaved: false });

        if (event.target.value.length == 0) {
            this.setState({ notes: null });
        }
    }

    handleTagChange(event) {
        this.setState({ tag: event.target.value, companySaved: false });

        if (event.target.value.length === 0) {
            this.setState({ tag: null });
        }
    }

    handleOffNameChange(event) {
        this.setState({ offName: event.target.value });

        if (event.target.value.length === 0) {
            this.setState({ offName: null });
        }
    }

    catNameWritten(value) {
        this.setState({ catName: value });
    }

    //inizio tag e multiple selection

    handleCat(value) {

        let deleted = false

        this.state.categoriesRemoved.map(links => {
            if (links == value) {
                deleted = true
            }
        })

        let doppione = false

        this.state.categoriesTag.map(tag => {
            if (tag.id == value) {
                doppione = true
            }
        })

        if (doppione && !deleted) {
            //categoria già selezionata
        } else if (doppione && deleted) {

            let oggetti = []

            this.state.categoriesTag.map(link => {
                if (link.id != value) {
                    oggetti.push({ name: link.name, id: link.id, remove: link.remove })
                }
                else {
                    oggetti.push({ name: link.name, id: link.id, remove: false })
                }
            })

            this.setState({ categoriesTag: oggetti });
        }
        else {
            this.state.categories.map(cat => {
                if (cat.catId == value) {
                    var id = parseInt(value)
                    this.state.categoriesTag.push({ name: cat.name, id: id, remove: false })
                }
            })
        }

        if (this.state.categoriesTag.length > 0) {
            this.setState({ mandatoryCat: true, compCatFieldEmptyAlert: false })
        }

        this.setState({ companySaved: false })
    }

    clearCat() {
        this.setState({ catName: '' })
    }

    removeTag(id) {
        this.state.categoriesRemoved.push(id)

        let oggetti = []

        this.state.categoriesTag.map(link => {
            if (link.id != id) {
                oggetti.push({ name: link.name, id: link.id, remove: link.remove })
            }
            else {
                oggetti.push({ name: link.name, id: link.id, remove: true })
            }
        })

        let atLeastOneShow = false
        oggetti.map(tag => {
            if (!tag.remove) {
                atLeastOneShow = true
            }
        })

        if (!atLeastOneShow) {
            this.setState({ mandatoryCat: false })
        }

        this.setState({ categoriesTag: oggetti, companySaved: false });
    }

    handleLink(value) {

        let deleted = false

        this.state.linksRemoved.map(links => {
            if (links == value) {
                deleted = true
            }
        })

        let doppione = false

        this.state.links.map(tag => {
            if (tag.id == value) {
                doppione = true
            }
        })

        if (doppione && !deleted) {
            //link già selezionato
        }
        else if (doppione && deleted) {

            let oggetti = []

            this.state.links.map(link => {
                if (link.id != value) {
                    oggetti.push({ name: link.name, id: link.id, remove: link.remove })
                }
                else {
                    oggetti.push({ name: link.name, id: link.id, remove: false })
                }
            })

            this.setState({ links: oggetti, companySaved: false });
        }
        else {
            fetch(
                `${SERVER_URL + 'api/company/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "companyId": value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 1,
                        "pageSizeOptions": null,
                        "CompanyNameStartWith": '',
                        "ExcludeParentId": this.state.compId,
                        "ExcludeId": this.state.compId,
                        "companyStatusList": [5, 1, 0, 4, 3],
                        "firstItemNumber": 0,
                        "ordering": {
                            "orderPropertyName": "companyId",
                            "order": -1
                        },
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {

                    let oggetti = this.state.links

                    oggetti.push({ name: res.data[0].name, id: value, remove: false })

                    this.setState({ links: oggetti, companySaved: false})
                })
        }
    }

    removeLinkTag(id) {
        //rimuove il link dai tag sottostanti la select e inserisce 
        this.state.linksRemoved.push(id)

        let oggetti = []

        this.state.links.map(link => {
            if (link.id != id) {
                oggetti.push({ name: link.name, id: link.id, remove: link.remove })
            }
            else {
                oggetti.push({ name: link.name, id: link.id, remove: true })
            }
        })

        this.setState({ links: oggetti, companySaved: false });
    };

    //fine tag e multiple selection

    handleTyp(value) {    
        let sonNoParent = false
        if (value != 1 && this.state.parentId == null) {
            sonNoParent = true
        }
        this.setState({ companyTypology: value, mandatoryTyp: true, companySaved: false, compTypFieldEmptyAlert: false, sonNoParent: sonNoParent  })
    }

    handleFather(value) {
        let sonNoParent = false
        if (this.state.companyTypology != 1 && value == null) {
            sonNoParent = true
        }
        this.setState({ parentId: value, companySaved: false, isBecomingSon: true, sonNoParent: sonNoParent })
    }

    switchChange = e => {
        if (e.target.value == 5 || e.target.value == 0 || e.target.value == 2) {

            if (e.target.value == 5 && this.state.parentId != null) {
                this.setState({ status: e.target.value, statusSon: 1, companySaved: false });
            } else {
                this.setState({ status: e.target.value, companySaved: false });
            }

        } else {
            this.setState({ status: 5, statusSon: e.target.value, companySaved: false });
        }
    };

    checkAllSaved(i) {

        let collPosfalse = document.getElementsByClassName('rolePositionFalse');
        let collDeletedRole = document.getElementsByClassName('roleDeletedtrue');
        var arrPosfalse = [].slice.call(collPosfalse);
        var arrDeletedRole = [].slice.call(collDeletedRole);

        Array.prototype.diff = function (a) {
            return this.filter(function (i) { return a.indexOf(i) < 0; });
        };

        var rolePositionFalse = arrPosfalse.diff(arrDeletedRole);

        let allOfficesAreSaved = document.getElementsByClassName('trueofficeBoxfalse').length < 1 && document.getElementsByClassName('falseofficeBoxfalse').length < 1 ? true : false
        let allRolesAreSaved = document.getElementsByClassName('trueclassRoleSavedfalse').length < 1 && rolePositionFalse.length < 1 ? true : false
        let allHrsAreSaved = document.getElementsByClassName('truefalsehrCreatedfalse').length < 1 && document.getElementsByClassName('falsefalsehrCreatedfalse').length < 1 ? true : false
        let allContactsAreSaved = document.getElementsByClassName('modifiedtrue').length < 1 ? true : false

        let msgCompanySaved = this.state.companySaved ? "" : message.warning("Warning, the company is not saved!");
        let msgOfficesSaved = allOfficesAreSaved ? "" : message.warning("Warning, one or more Offices are not saved!");
        let msgRolesSaved = allRolesAreSaved ? "" : message.warning("Warning, one or more Roles are not saved!");
        let msgHrsSaved = allHrsAreSaved ? "" : message.warning("Warning, one or more Hrs are not saved!");
        let msgContactsSaved = allContactsAreSaved ? "" : message.warning("Warning, one or more Contacts are not saved!");


        if (this.state.companySaved && allOfficesAreSaved && allRolesAreSaved && allHrsAreSaved && allContactsAreSaved) {
            this.setState({ allSaved: true });
            message.success('All data are currently saved');
            switch (i) {
                case 2:
                    return (
                        window.setTimeout(function () {
                            window.location = "/create/";
                        }, 500)
                    );
                case 3: //Add child company
                    return window.open("/create?id=" + `${this.state.compId}` + "&typology=1", '_blank');
                case 4: //Add brand
                    return window.open("/create?id=" + `${this.state.compId}` + "&typology=2", '_blank');
                case 5: //Add sign
                    return window.open("/create?id=" + `${this.state.compId}` + "&typology=17", '_blank');
                case 6://Add department
                    return window.open("/create?id=" + `${this.state.compId}` + "&typology=20", '_blank');
            }
        } else {
            msgCompanySaved
            msgOfficesSaved
            msgRolesSaved
            msgHrsSaved
            msgContactsSaved
            this.setState({ allSaved: false });
        }    
    }

    checkAndRestart() {
        this.checkAllSaved()

        if (this.state.allSaved) {
            message.success('All data are currently saved');

            window.setTimeout(function () {
                window.location = "/create/";
            }, 500)
        }
        else {
            this.checkAllSaved()
        }
    }

    saveCompany() {
        let status = this.state.status
        if (status == 5 && this.state.parentId != null) { status = this.state.statusSon }
        if (this.state.sameNameComp.length === 0) {
            let piva = null
            if (this.state.pIva !== '') {
                piva = this.state.pIva
            }

            if (this.state.companyTypology !== '' && this.state.categoriesTag !== [] && this.state.compName !== '' && this.state.compCreated === true) {
                this.setState({ loading: true })

                let oggetti = []

                this.state.categoriesTag.map(tag => {
                    if (!tag.remove) {
                        oggetti.push(tag.id)
                    }
                })

                fetch(`${SERVER_URL + 'api/company'}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        "name": this.state.compName,
                        "companyTypologyTrValue": this.state.companyTypology,
                        'companyImage': this.state.companyImage,
                        'description': this.state.description,
                        'sort': this.state.sort,
                        'companyId': this.state.compId,
                        'CompanyProducerCompanyId': this.state.producerId,
                        'CompanyDistributorCompanyId': this.state.distributerId,
                        'CompanyLicenserCompanyId': this.state.licenserId,
                        'companyParentCompanyId': this.state.parentId,
                        'pIva': piva,
                        'notes': this.state.notes,
                        "Workflow": this.state.workFlow,
                        "Status": status,
                        "imageType": this.state.imageType,
                        "footer": this.state.footer
                    })
                }).then(response => response.json())
                    .then(res => {
                        this.setState({ loading: false, companySaved: true })

                        this.saveCategories(0)
                        this.addLink();
                        if (this.state.isBecomingSon == true && this.state.parentId != null) {
                            this.sendData(this.state.compId)
                        }
                    }
                )
            }
        }
        else {
            this.setState({ showSameName: true })
        }       

        
    }

    changeToEdit() {
        //alla creazione della compagnia, ti porta nel componente edit
        let linkId = this.state.parentId != null ? this.state.parentId : this.state.compId

        window.location = "/edit?id=" + this.state.compId;
    }

    saveCategories(i) {
        let tag = this.state.categoriesTag[i]

        if (!tag.remove) {
            fetch(
                `${SERVER_URL + 'api/BrCompanyCategory'}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'companyId': this.state.compId,
                    'catId': tag.id
                })
            }).then(response => response.json())
                .then(res => {
                    if (res.data === 0) {
                        fetch(
                            `${SERVER_URL + 'api/BrCompanyCategory'}`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                'companyId': this.state.compId,
                                'catId': tag.id,
                                "isDeleted": false
                            })
                        }
                        )
                    }
                    if (this.state.categoriesTag.length != i + 1) {
                        this.saveCategories(i + 1)
                    }
                })
        } else {
            fetch(
                `${SERVER_URL + `api/BrCompanyCategory/hard/${this.state.compId}/${tag.id}`}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                }
            }).then(response => response.json())
                .then(res => {
                    if (this.state.categoriesTag.length != i + 1) {
                        this.saveCategories(i + 1)
                    }
                })
        }
    }

    deleteCompany() {
        if (this.state.compCreated) {
            fetch(
                `${SERVER_URL + 'api/company/' + this.state.compId + '?lang=en'}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                }
            ).then(response => response.json())
                .then(res => {
                    fetch(
                        `${SERVER_URL + 'api/company/' + this.state.compId}`, {
                            method: 'DELETE',
                            headers: {
                                'Authorization': `Bearer ${this.state.user}`,
                                'Content-Type': 'application/json'
                            }
                        }
                    ).then(response => response.json())
                        .then(res => {
                            var id = this.state.parentId
                            if (id != null) {
                                window.location = "/edit?id=" + id;
                            } else {
                                window.location = "/";
                            }
                        }
                    )
                })
        }
        else {
            //stai eliminando una comp non creata
        }
        this.setState({ compCreated: false, offCreated: false, detailsOff: [], hasBeenDeleted: true })
    }

    saveOffice(id, name) {
        if (this.state.offCreated) {
            this.setState({ loading: true })
            fetch(`${SERVER_URL + 'api/Office'}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'name': `${name}`,
                    'officeid': `${this.state.officeId}`,
                    'companyId': `${id}`,
                    'sort': 1
                })
            }).then(this.setState({ loading: false }))
        }
        else {
            this.setState({ loading: true })
            fetch(
                `${SERVER_URL + "api/office"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': `${name}`,
                        'companyId': `${id}`,
                        'sort': 1,
                        'IsPrincipal': true
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ offCreated: true, officeId: res.data, loading: false }, () => {
                        fetch(
                            `${SERVER_URL + "api/brHrRoleOffice"}`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${this.state.user}`
                                },
                                body: JSON.stringify({
                                    'officeId': `${res.data}`,
                                })
                            }
                        ).then(response => response.json())
                            .then(res => {
                                this.setState({ hroId: res.data });
                            }
                            )
                    })
                }
                );
        }
    }

    searchCompany(value, conditioner) {
        if (value == undefined) {
            fetch(
                `${SERVER_URL + 'api/company/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 15,
                        "TypologyName": "Company",
                        "ExcludeParentId": this.state.compId,
                        "ExcludeId": this.state.compId,
                        "companyStatusList": [5, 1, 0, 4, 3],
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    var noSelf = []
                    var noSelfBS = []

                    res.data.map(comp => {
                        if (comp.companyTypologyTrValue == 1) {
                            if (comp.companyId !== this.state.compId) {
                                noSelf.push(comp)
                            }
                        }
                        if (comp.companyId !== this.state.compId) {
                            noSelfBS.push(comp)
                        }
                    })

                    this.setState({ companies: noSelf, companiesBrandsSigns: noSelfBS, parentId: null, companySaved: false });

                    if (this.state.companyTypology != 1 && value == undefined) {
                        this.setState({ sonNoParent: true, companySaved: false })
                    }
                })
        } else if (value.length >= 3 || value.length === 0) {
            //companies
            fetch(
                `${SERVER_URL + 'api/company/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CompanyNameStartWith": `${value + "%"}`,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 15,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0,
                        "companyStatusList": [5, 1, 0, 4, 3],
                        "ExcludeParentId": this.state.compId,
                        "ExcludeId": this.state.compId,
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        var noSelf = []
                        var noSelfBS = []

                        res.data.map(comp => {
                            if (comp.companyTypologyTrValue == 1) {
                                if (comp.companyId !== this.state.compId) {
                                    noSelf.push(comp)
                                }
                            } 
                            if (comp.companyId !== this.state.compId) {
                                noSelfBS.push(comp)
                            }                            
                        })

                        this.setState({ companies: noSelf, companiesBrandsSigns: noSelfBS });
                    } else {
                        this.setState({ companies: [], companiesBrandsSigns: [] });
                    }
                })
            if (value.length == 0) {
                if (conditioner == 1) {
                    this.setState({ producerId: null })
                } else if (conditioner == 2) {
                    this.setState({ distributerId: null })
                } else if (conditioner == 3) {
                    this.setState({ licenserId: null })
                } else if (conditioner == 4) {
                    this.setState({ parentId: null })
                }
            }
            this.setState({ companySaved: false })
        }
    }

    getFiles(files) {
        if (files.length !== 0) {
            this.setState({ companyImage: files.base64, imageType: files.type, companySaved: false });
        } else {
            this.setState({ companyImage: '' });
        }
    }

    handleHro(value) {
        this.setState({ hroId: value });
    }

    //marchi
    handleProd(value) {
        this.setState({ producerId: value, companySaved: false });
    }

    handleDist(value) {
        this.setState({ distributerId: value, companySaved: false });
    }

    handleLicn(value) {
        this.setState({ licenserId: value, companySaved: false });
    }

    //fine marchi

    handleContactText(event) {
        this.setState({ officeContactText: event.target.value });
    }

    addLink() {
        this.state.links.map(link => {
            if (!link.remove) {
                fetch(
                    `${SERVER_URL + "api/companylink"}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        },
                        body: JSON.stringify({
                            "CompanyId": this.state.compId,
                            "CompanyLinkToCompanyId": link.id
                        })
                    }
                )
            }
            else {
                fetch(
                    `${SERVER_URL + `api/companylink/hard/${this.state.compId}/${link.id}`}`, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.state.user}`
                        }
                    }
                )
            }
        }
        )
    }

    deleteOffice = (id, index) => {
        fetch(
            `${SERVER_URL + 'api/office/hard/' + id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => response.json())
        .then(res => {
            if (res.ok) {
                if (this.state.detailsOff.length > 1) {
                    let newOffice = this.state.detailsOff

                    newOffice[index].show = false

                    var order = newOffice[index].sort

                    newOffice.map((off, i) => {
                        if (off.sort > order) {
                            newOffice[i].sort = off.sort - 1
                            
                        }
                    })

                    this.setState({ detailsOff: newOffice })
                } else {
                    this.setState({ detailsOff: [] })
                }
            }
        })
    }

    //pulsanti add sotto
    addChildComp() {
        window.location = `"/create?id=" + ${this.state.compId}`
    }

    //pulsanti add a lato
    addOff() {
        if (this.state.compCreated) {
            var id = this.state.detailsOff.length + 1;

            this.setState({ position: 'absolute', offId: id, everyOffCreated: false })
            this.state.detailsOff.push({data: null, id: id, show: true, sort: id})
        }
        else {
            //stai creando un office senza avere la company
        }
    }

    offCreated() {
        this.setState({ everyOffCreated: true })
    }

    handleSort(value) {
        this.setState({sort: value})
    }

    moveOffice(id, order, orderUp) {
        let offices = this.state.detailsOff

        if (orderUp) {
            var indexOff = offices.findIndex(obj => obj.sort == order - 1);
            offices[id].sort = offices[id].sort - 1

            offices[indexOff].sort = order
        } else {
            var indexOff = offices.findIndex(obj => obj.sort == order + 1);
            offices[id].sort = offices[id].sort + 1

            offices[indexOff].sort = order
        }
        this.setState({ detailsOff: offices })
    }

    sendData = (input) => {
        this.props.parentCallback(input);
    }
    
    render() {

        let blockFooter = true

        let detail = !this.state.hasDetail ?
            ''
            :
            <Modal
                key={this.state.companyDetail.companyId}
                title={this.state.companyDetail.name}
                onCancel={() => this.setState({ visible: false, loadingDetail: false })}
                visible={this.state.visible}
                footer={null}
            >
                <CardDetailed crossFetch={this.reloadPage} getDetail={this.loadNewEdit} token={this.state.user} company={this.state.companyDetail} blockFooter={blockFooter} />
            </Modal>

        let mandatory1 = !this.state.mandatoryCompanyName ? <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" style={{ left: '0px', marginLeft: '10px' }} /></Tooltip> : <Icon type="check-circle" style={{ left: '0px', marginLeft: '10px' }} />

        let mandatory2 = !this.state.mandatoryTyp ? <Tooltip title="This field is mandatory"><Icon className="iconSelect" type="exclamation-circle" style={{ left: '0px', marginLeft: '10px' }} /></Tooltip> : <Icon className="iconSelect" type="check-circle" style={{ left: '0px', marginLeft: '10px' }} />

        let mandatory3 = !this.state.mandatoryCat ? <Tooltip title="This field is mandatory"><Icon className="iconSelect" type="exclamation-circle" style={{ left: '0px', marginLeft: '10px' }} /></Tooltip> : <Icon className="iconSelect" type="check-circle" style={{ left: '0px', marginLeft: '10px' }} />

        let companySaved = this.state.companySaved && this.state.mandatoryCompanyName ? true : false

        let createANewOffice = this.state.everyOffCreated ? <Button onClick={this.addOff} className="createOfficeButton" icon="plus">Office</Button> : <Button disabled className="createOfficeButton" icon="plus">Office</Button>

        let listacat = this.state.categories.map(cat =>
            <Option key={cat.catId}>{cat.name}</Option>
        )

        let tagCat = this.state.categoriesTag.map(tag => {
            if (!tag.remove) {
                return (
                    <Tag className="cat" closable key={tag.id} onClick={() => this.removeTag(tag.id)}>
                        <span>{tag.name}</span>
                    </Tag>
                )
            }
        }
        )

        let linkCat = this.state.links.map(link => {
            if (!link.remove) {
                return (
                    <Tag className="link" closable key={link.id} onClick={() => this.removeLinkTag(link.id)}>
                        <span>{link.name}</span>
                    </Tag>
                )
            }
        }
        )

        let listatyp = this.state.tipologies.map(tip =>
            <Option key={tip.value}>{tip.text}</Option>
        )

        let listacompany = this.state.companies.map(comp =>
                <Option key={comp.companyId}>{comp.name}</Option>
        )

        let listacompanyBS = this.state.companiesBrandsSigns.map(comp =>
            <Option key={comp.companyId}>{comp.name}</Option>
        )

        let notUniqueName = this.state.showSameName ?

            <Modal
                className="modale"
                title="This name already exists. Continue?"
                onCancel={() => this.setState({ showSameName: false })}
                visible={this.state.showSameName}
                onOk={this.saveUniqueName}
                maskClosable={false}
            >
                <p>Click one of the links below to start editing that company</p>

                <ul className="sameNameComp">
                    {this.state.sameNameComp.map(comp =>
                        <li key={comp.companyId}><Link to={"/edit?id=" + comp.companyId} >{comp.name} - {comp.brCompanyCategories.map(cat => <span className="catWizardLink" key={cat.catId}>{cat.companyCategories.name}</span>)}</Link></li>
                    )}
                </ul>
            </Modal>

            : ""

        let zonaMarchioTOrF = this.state.companyTypology == 2 || this.state.companyTypology == 17 ? true : false

        let contents = this.state.loading ? <Icon className={"wizardUpdating " + this.state.compCreated} type="sync" spin /> : <div className={"wizardSaved " + this.state.compCreated}><Icon type="sync" /> Contenuto aggiornato</div>;

        let imageContent = <div><p className="fakeLink" style={{ display: 'block' }} onClick={this.deleteImage}><Icon style={{color: 'red'}} type="close" /> Remove image</p><img className="popoverImage" src={'data:' + this.state.imageType + ';base64,' + this.state.companyImage} /></div>

        let iconImage = this.state.companyImage !== null && this.state.companyImage !== '' ? <Popover content={imageContent}><div style={{ backgroundImage: 'url(' + `${'data:' + this.state.imageType + ';base64,' + this.state.companyImage}` + ')' }} className="trueWizardImage"></div></Popover> : <div className="fakeWizardImage">{this.state.compName.charAt(0)}</div>

        let pivaShort = this.state.pivaTooShort ? true : false

        let pivaLong = this.state.pivaTooLong ? true : false

        let companyDelete = this.state.compCreated ? <Popconfirm placement="top" title={"Are you sure you want to move this " + this.props.company.companyTypology.text + " and all its children to the bin?"} onConfirm={this.deleteCompany} okText="Yes" cancelText="No"><Button className="deleteButtonHrWizard newComp" style={{ margin: '0px 15px', boxShadow: '0px 0px 4px 0px red' }}><Icon type="delete" /> Delete {this.props.company.companyTypology.text}</Button></Popconfirm> : <Button disabled className="deleteButtonHrWizard"><Icon type="delete" /> Delete {this.props.company.companyTypology.text}</Button>

        let parentName = this.state.company.companyParent != null ? this.state.company.companyParent.name : null

        let producerName = this.state.company.companyProducer != null ? this.state.company.companyProducer.name : null

        let distributerName = this.state.company.companyDistributor != null ? this.state.company.companyDistributor.name : null

        let licenserName = this.state.company.companyLicenser != null ? this.state.company.companyLicenser.name : null

        let isNotDepartment = this.state.companyTypology === 20 ? '' : <Popconfirm placement="top" title="Are you sure you want to leave this page?" onConfirm={() => this.checkAllSaved(3)} okText="Yes" cancelText="No"><Button className="newComp">Add child Company</Button></Popconfirm>

        let itsStillNotADepartment = this.state.companyTypology === 20 ? '' : <Popconfirm placement="top" title="Are you sure you want to leave this page?" onConfirm={() => this.checkAllSaved(6)} okText="Yes" cancelText="No"><Button className="newComp">Add related Department</Button></Popconfirm>

        let addChildIfNotChild = this.state.companyTypology === 1 || this.state.companyTypology === 20 ?
            <div className="rightButtonsWizard">
                {isNotDepartment}
                <Popconfirm placement="top" title="Are you sure you want to leave this page?" onConfirm={() => this.checkAllSaved(4)} okText="Yes" cancelText="No"><Button className="newComp">Add related Brand </Button></Popconfirm>
                <Popconfirm placement="top" title="Are you sure you want to leave this page?" onConfirm={() => this.checkAllSaved(5)} okText="Yes" cancelText="No"><Button className="newComp">Add related Sign</Button></Popconfirm>
                {itsStillNotADepartment}
            </div>
            : ''

        let mandatoryAreNotMet = <p><Icon type="exclamation-circle" style={{ color: 'red' }} /> One or more mandatory fields are empty</p>

        let allSavedBlock = <p>Everything already Saved</p>

        let saveButtonSwitch = this.state.compName === '' || !this.state.compName || this.state.companyTypology === '' || !this.state.mandatoryCat || this.state.sonNoParent ? <Popover content={mandatoryAreNotMet}><Button disabled className="saveButtonHrWizard" icon="save"> Save {this.props.company.companyTypology.text}</Button></Popover> : this.state.companySaved ? <Popover content={allSavedBlock}><Button disabled className="saveButtonHrWizard" icon="save"> Save {this.props.company.companyTypology.text}</Button></Popover> : <Button onClick={this.saveCompany} className="saveButtonHrWizard" icon="save" > Save {this.props.company.companyTypology.text}</Button>

        let chooseOneFFS = this.state.companyTypology != 1 && this.state.parentId == null ? <Tooltip title="This field is mandatory"><Icon className="iconSelect" type="exclamation-circle" style={{ left: '0px', marginLeft: '10px' }} /></Tooltip> : this.state.companyTypology != 1 && this.state.parentId != null ? <Icon className="iconSelect" type="check-circle" style={{ left: '0px', marginLeft: '10px' }} /> : ''

        let compTypoName = this.state.companyTypology == 2 ? "Brand" : this.state.companyTypology == 17 ? "Sign" : this.state.companyTypology == 20 ? "Department"  : "Company"

        let partitaIVa = this.state.companyTypology == 2 || this.state.companyTypology == 17 || this.state.companyTypology == 20 ?
            <Popover content={"A " + compTypoName + " can't have a Vat Number"}>
                <Input autoComplete="new-password" disabled defaultValue={this.state.pIva} className={"anticonNoTop pIva" + pivaShort + pivaLong} onChange={this.handlePiva} style={{ width: '100%', height: '52px' }} placeholder="Vat number" />
            </Popover>
            :
            <Input autoComplete="new-password" defaultValue={this.state.pIva} className = { "anticonNoTop pIva" + pivaShort + pivaLong } onChange = { this.handlePiva } style = {{ width: '100%', height: '52px' }} placeholder = "Vat number" />

        let secondRadioGroup = this.state.status == 5 && this.state.parentId != null ?
            <Radio.Group onChange={this.switchChange} value={this.state.statusSon}>
                <Radio.Button value={3}>Inside Owner</Radio.Button>
                <Radio.Button value={1}>Alone</Radio.Button>
                <Radio.Button value={4}>Everywhere</Radio.Button>
            </Radio.Group> : <Radio.Group disabled onChange={this.switchChange} value={this.state.statusSon}>
                <Radio.Button value={3}>Inside Owner</Radio.Button>
                <Radio.Button value={1}>Alone</Radio.Button>
                <Radio.Button value={4}>Everywhere</Radio.Button>
            </Radio.Group>

        let extraButtons = this.state.company.companyParentCompanyId ?
            <div style={{ height: '40px', display: 'inline-flex' }}>
                <p style={{ padding: 13 }}><Icon type="arrow-right" /></p>
                <div style={{ height: '40px' }}>
                    {secondRadioGroup}
                </div>
            </div> : null

        let brandOrSignCommands = this.state.companyTypology == 2 ? <h4> Brand's data:</h4> : <h4> Sign's data:</h4>

        

        let collabOf = this.state.companyCollaborationFor.length > 0 ?
            <ul className="noStyle">
                {this.state.companyCollaborationFor.map(el => {
                    let hiddenStyle = el.status == 0 ? 'hiddenLink' : 'fakeLink'
                    return <li key={el.companyId}><Link to="#" onClick={() => this.showModal(el.companyId)} className={hiddenStyle}>{el.name}</Link></li>
                })}
            </ul>
            :
            <span>None</span>

        let referbOf = this.state.companyLinkedMe.length > 0 ?
            <ul className="noStyle">
                {this.state.companyLinkedMe.map(el => {
                    let hiddenStyle = el.status == 0 ? 'hiddenLink' : 'fakeLink'
                    return <li key={el.companyId}><Link to="#" onClick={() => this.showModal(el.companyId)} className={hiddenStyle}>{el.name}</Link></li>
                })}
            </ul>
            :
            <span>None</span>

        let prodOf = this.state.companyProducedByMe.length > 0 ?
            <ul className="noStyle">
                {this.state.companyProducedByMe.map(el => {
                    let hiddenStyle = el.status == 0 ? 'hiddenLink' : 'fakeLink'
                    return <li key={el.companyId}><Link to="#" onClick={() => this.showModal(el.companyId)} className={hiddenStyle}>{el.name}</Link></li>
                })}
            </ul>
            :
            <span>None</span>

        let distrOf = this.state.companyDistributedByMe.length > 0 ?
            <ul className="noStyle">
                {this.state.companyDistributedByMe.map(el => {
                    let hiddenStyle = el.status == 0 ? 'hiddenLink' : 'fakeLink'
                    return <li key={el.companyId}><Link to="#" onClick={() => this.showModal(el.companyId)} className={hiddenStyle}>{el.name}</Link></li>
                })}
            </ul>
            :
            <span>None</span>

        let licenbOf = this.state.companyLicensedByMe.length > 0 ?
            <ul className="noStyle">
                {this.state.companyLicensedByMe.map(el => {
                    let hiddenStyle = el.status == 0 ? 'hiddenLink' : 'fakeLink'
                    return <li key={el.companyId}>-<Link to="#" onClick={() => this.showModal(el.companyId)} className={hiddenStyle}>{el.name}</Link></li>
                })}
            </ul>
            :
            <span>None</span>

        return ( 
            <Col className={"wizardFields companyWizard wizardCompany" + " " + this.state.workFlow + " hasBeenDeleted" + this.state.hasBeenDeleted} sm="12" style={{ marginBottom: '100px' }}>
                {notUniqueName}
                <h6 style={{ padding:'0 15px' }}>{this.props.company.companyTypology.text} details</h6>
                <Row className={"companySavedBox" + companySaved}>
                    <InputNumber autoComplete="new-password" min={1} max={1000} className="sortingInput" value={this.state.sort} onChange={this.handleSort} />
                    <Col sm="6">
                        <div className="wizardCompanyCreation">
                            <div className="compNameAndStatus">
                                <div className="wizardCompName">
                                    <h4 className="visibleLabeltrue">
                                        <Tooltip placement="topLeft" title={"Insert the " + this.props.company.companyTypology.text + " here"}>
                                            <Icon className="iconSelect" type="info-circle" />
                                        </Tooltip>
                                        {this.props.company.companyTypology.text} Name:
                                    </h4>
                                    <Input autoComplete="new-password" onBlur={this.isNameUnique} value={this.state.compName} className={"baseInput" + " name" + this.props.i + " companyNameWizard companyNameValidation" + this.state.compNameFieldEmptyAlert} placeholder="Company Name" allowClear={true} onChange={this.handleNameChange} style={{ height: '40px' }} />
                                    <p style={{ color: 'red', float: "left", position: "absolute", display: this.state.sameNameComp.length < 1 ? "none" : "block" }} className={this}>This name is already been used by another company</p>

                                    {mandatory1}
                                </div>
                                <div className="statusBox">

                                    <Tooltip placement="topLeft" title="Insert here the company logo, 600px x 600px recommended maximum dimensions">
                                        <h4><Icon type="info-circle" /> Company Logo:</h4>
                                    </Tooltip>

                                    <div className="wizardInputs">
                                        <FileBase64 onDone={this.getFiles.bind(this)} />

                                        {iconImage}
                                    </div>
                                    <span id="wrongSize" className="warningWizard" >Warning, file size is too big (max 150 kb)</span>
                                    <span id="wrongExtension" className="warningWizard">Warning, only .png, .jpg, .jpeg and .svg accepted</span>

                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col sm="6">

                        <div className="firstBlock">
                            <div className="blockTypology">
                                <Tooltip placement="topLeft" title="Select a Typology">
                                    <h4><Icon type="info-circle" /> Typology:</h4>
                                </Tooltip>

                                <div style={{ display: 'flex', height: '35px' }}>
                                    <Select
                                        mode="single"
                                        className={'selectWizard darkSelect companyTypValidation' + this.state.compTypFieldEmptyAlert}
                                        placeholder="Typology"
                                        style={{ width: '100%', fontWeight: '500' }}
                                        onChange={this.handleTyp}
                                        defaultValue={this.props.company.companyTypology.text}
                                    >
                                        {listatyp}
                                    </Select>
                                    {mandatory2}
                                </div>

                            </div>
                            <div className="blockCategory">
                                <Tooltip placement="topLeft" title="Select one or more categories related to the company">
                                    <h4><Icon type="info-circle" /> Category:</h4>
                                </Tooltip>

                                <div style={{ display: 'flex' }}>

                                    <AutoComplete
                                        dataSource={listacat}
                                        onBlur={this.clearCat}
                                        style={{ width: '100%' }}
                                        onSelect={this.handleCat}
                                        id="clearOnSelect"
                                        placeholder="Categories"
                                        value={this.state.catName}
                                        onSearch={this.catNameWritten}
                                        onChange={this.clearCat}
                                        className={"selectCategory darkSelect companyCatValidation" + this.state.compCatFieldEmptyAlert}
                                        filterOption={(inputValue, option) =>
                                            option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    />

                                    {mandatory3}
                                </div>
                                <div className="linkLink categoryTags">
                                    {tagCat}
                                </div>
                            </div>

                        </div>

                    </Col>

                    <Col sm="12" className={"zonaMarchio" + zonaMarchioTOrF} style={{ paddingLeft: '14px', paddingRight: '14px' }}>
                        <hr style={{ marginTop: '10px', marginBottom: '0px' }} />

                        <div className="brandBox">

                            <div style={{ padding: '0px 15px', display: 'inline-flex', width: '100%' }}>

                                <div className="brandLabel brandLabelWidth">
                                    {brandOrSignCommands}
                                </div>

                                <div className="brandSelectWidth">
                                    <div style={{ display: 'block', width: '100%' }}>
                                        <Tooltip placement="topLeft" title="If empty, office name will be the same as company name">
                                            <h4><Icon type="info-circle" /> Producer:</h4>
                                        </Tooltip>

                                        <AutoComplete
                                            dataSource={listacompany}
                                            style={{ width: '90%', display: 'inline-flex' }}
                                            onSelect={this.handleProd}
                                            onChange={(value) => this.searchCompany(value, 1)}
                                            placeholder="Producer"
                                            defaultValue={producerName}
                                        />

                                    </div>

                                    <div style={{ display: 'block', width: '100%' }}>

                                        <Tooltip placement="topLeft" title="If empty, office name will be the same as company name">
                                            <h4><Icon type="info-circle" /> Distributer:</h4>
                                        </Tooltip>

                                        <AutoComplete
                                            dataSource={listacompany}
                                            style={{ width: '90%', display: 'inline-flex' }}
                                            onSelect={this.handleDist}
                                            onChange={(value) => this.searchCompany(value, 2)}
                                            placeholder="Distributer"
                                            defaultValue={distributerName}
                                        /> 

                                    </div>

                                    <div style={{ display: 'block', width: '100%' }}>

                                        <Tooltip placement="topLeft" title="If empty, office name will be the same as company name">
                                            <h4><Icon type="info-circle" /> Licenser:</h4>
                                        </Tooltip>

                                        <AutoComplete
                                            dataSource={listacompany}
                                            style={{ width: '90%', display: 'inline-flex' }}
                                            onSelect={this.handleLicn}
                                            onChange={(value) => this.searchCompany(value, 3)}
                                            placeholder="Licenser"
                                            defaultValue={licenserName}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr style={{ marginTop: '0px', marginBottom: '15px' }} />
                    </Col>

                    <Col sm="12" style={{ display: 'inline-flex', padding: '0px' }}>

                        <Col sm="6">
                            <div className="wizardCompanyCreation">

                                <div className="secondBlock">

                                    <div className="createCompImgBlock">

                                        <Tooltip placement="topLeft" title="If the company has a parent company, select it here">
                                            <h4><Icon type="info-circle" /> Parent/Owner:</h4>
                                        </Tooltip>

                                        <div style={{ display: 'flex' }}>
                                            <AutoComplete
                                                dataSource={listacompany}
                                                style={{ width: '100%' }}
                                                onSelect={this.handleFather}
                                                onChange={(value) => this.searchCompany(value, 4)}
                                                placeholder="Parent"
                                                defaultValue={parentName}
                                                allowClear
                                                className="handleTyp"
                                            />
                                            {chooseOneFFS}
                                        </div>

                                    </div>

                                    <div className="createCompParentBlock" style={{ width: '55%' }}>

                                        <Tooltip placement="topLeft" title="Associate this company to another one">
                                            <h4><Icon type="info-circle" /> Reference:</h4>
                                        </Tooltip>

                                        <AutoComplete
                                            dataSource={listacompanyBS}
                                            style={{ width: '100%' }}
                                            onSelect={this.handleLink}
                                            onChange={this.searchCompany}
                                            placeholder="References"
                                        />

                                        <div className="linkLink">
                                            {linkCat}
                                        </div>

                                    </div>

                                </div>

                                <div className="thirdBlock leftCol">
                                    <Row>
                                        <Col sm="6">
                                            <Tooltip placement="topLeft" title="Write any additional information about the company">
                                                <h4 id="h4Desc" style={{ marginTop: '20px' }}><Icon type="info-circle" /> Description:</h4>
                                            </Tooltip>
                                            <TextArea className="textareaWizard" autosize={{ minRows: 2, maxRows: 15 }} style={{ width: '100%' }} placeholder="Description" value={this.state.description} onChange={this.handleDescriptionChange} />
                                        </Col>

                                        <Col sm="6">
                                            <Tooltip placement="topLeft" title="Write any additional information about the company">
                                                <h4 id="h4Desc" style={{ marginTop: '20px' }}><Icon type="info-circle" /> Footer:</h4>
                                            </Tooltip>
                                            <TextArea className="textareaWizard" autosize={{ minRows: 2, maxRows: 15 }} style={{ width: '100%' }} placeholder="Footer" value={this.state.footer} onChange={this.handleFooterChange} />
                                        </Col>
                                    </Row>
                                </div>

                            </div>
                        </Col>

                        <Col sm="6">

                            <div className="secondBlock" style={{ marginBottom: '2.5em' }}>

                                <div className="createCompParentBlock" style={{ marginLeft: 0 }}>

                                    <Tooltip placement="topLeft" title="Let the company be visible or hidden in the companies list">
                                        <h4 className="visibleLabeltrue"><Icon type="info-circle" /> Status:</h4>
                                    </Tooltip>

                                    <div style={{ width: '100%', display: 'flex' }}>
                                        <div style={{ height: '40px' }}>
                                            <Radio.Group onChange={this.switchChange} value={this.state.status}>
                                                <Radio.Button value={0}>Hidden</Radio.Button>
                                                <Radio.Button value={2}>Disabled</Radio.Button>
                                                <Radio.Button value={5}>Visible</Radio.Button>
                                            </Radio.Group>
                                        </div>
                                        {extraButtons}
                                    </div>

                                </div>

                            </div>

                            <div className="thirdBlock rightCol">

                                <div className="sharingIsCaring">

                                    <Tooltip placement="topLeft" title="VAT number">
                                        <h4><Icon type="info-circle" /> Vat number:</h4>
                                    </Tooltip>
                                    {partitaIVa}
                                    <p className={"pIvaShort" + this.state.pivaTooShort}>Input must be equal to 11 numbers</p>
                                    <p className={"pIvaLong" + this.state.pivaTooLong}>Input must be equal to 11 numbers</p>
                                </div>

                                <div className="sharingIsCaring">

                                    <Tooltip placement="topLeft" title="This field will not be shown in the company card, it is for internal use only">

                                        <h4><Icon type="info-circle" /> Internal Notes:</h4>
                                    </Tooltip>

                                    <TextArea autosize={{ minRows: 2, maxRows: 15 }} style={{ width: '100%' }} value={this.state.notes} placeholder="Notes" onChange={this.handleNoteChange} />

                                </div>

                            </div>
                        </Col>

                    </Col>

                    <div className="buttonsCreateCompany">
                        {saveButtonSwitch}
                    </div>

                </Row>

                <Row>
                    <Col style={{ padding: '0' }} sm="12">
                        <hr style={{ marginTop: '30px', marginBottom: '0' }} />
                        <div className="wizardParagraph newOfficeDiv">
                            
                            {this.state.detailsOff.map((off, i) => {
                                let status = this.state.status == 5 || this.state.status == 3 || this.state.status == 4 || this.state.status == 1 ? 1 : 0
                                        if (off.data != null && off.show) {
                                            return (
                                                <EditOff moveOffice={this.moveOffice} principalOk={this.principalOk} offLength={this.state.detailsOff.length} id={i} data={off.data} deleteOffice={this.deleteOffice} idOffice={off.sort} status={status} user={this.state.user} properties={this.state.properties} key={i} i={i + 1} companyId={this.state.compId} everyOffCreated={this.state.everyOffCreated} isThereAPrincipal={this.state.principal} />
                                            )
                                        } else if (off.show) {
                                            return (
                                                <HandleOff moveOffice={this.moveOffice} principalOk={this.principalOk} offCreated={this.offCreated} offLength={this.state.detailsOff.length} id={i} deleteOffice={this.deleteOffice} status={status} user={this.state.user} properties={this.state.properties} i={i + 1} key={i} idOffice={off.sort} companyId={this.state.compId} everyOffCreated={this.state.everyOffCreated} isThereAPrincipal={this.state.principal} />
                                            )
                                        }
                                    })
                                }
                        </div>
                        {createANewOffice}
                    </Col>

                    <div style={{ display: 'flex', width: '100%' }}>
                        <div className="leftButtonsWizard">
                            <Button onClick={() => this.checkAllSaved(1)} className="newComp" style={{ boxShadow: '0px 0px 4px 0px green', zIndex: '10' }}>Check Data</Button>
                            {companyDelete}
                        </div>
                        {addChildIfNotChild}
                    </div>
                </Row>
                <Row className="rowReference" style={{ marginTop: '75px', padding: '0px 30px', borderTop:'2px solid #d6d6d6', paddingTop:'30px' }}>
                    
                    <div style={{width:"100%"}}>
                        <h6>External relationships</h6>
                    </div>
                    <div className="specialCol">
                        <h4>Collaborator of:</h4>
                        {collabOf}
                    </div>
                    <div className="specialCol">
                        <h4>Referenced of:</h4>
                        {referbOf}
                    </div>
                    <div className="specialCol">
                        <h4>Producer of:</h4>
                        {prodOf}
                    </div>
                    <div className="specialCol">
                        <h4>Distributor of:</h4>
                        {distrOf}
                    </div>
                    <div className="specialCol">
                        <h4>Licensee of:</h4>
                        {licenbOf}
                    </div>            
                </Row>
                {detail}
            </Col>

        );
    }
}

export default EditComp;


// WEBPACK FOOTER //
// ./src/EditWizard/EditComp.js